export const isInsecureUrl = (url: string | null | undefined): boolean => {
  return !!url && url.startsWith('http://');
};
